import { JobType } from '../../constants';
import { createTableSlice } from '../helpers';

export const tableSlice = createTableSlice({
  name: 'automatedJobs/labelCheckTable',
  url: '/api/jobs',
  filters: {
    type: JobType.LABEL_CHECK,
  },
  sortOrder: 'desc',
  orderBy: 'id',
});
